export enum OnboardingSteps {
  BusinessProfile = 1,
  WebsiteAccess = 2,
  ContentSurvey = 3
}
